import { fromJS } from "immutable";

const initClientData = fromJS({});

const initFilterDataClient = fromJS({
  clientName: "",
  aplSalesOffice: "",
  pageNo: 1,
  pageSize: 10,
});

export function clientData(state = initClientData, action) {
  switch (action.type) {
    case "CLIENT_FETCH_DATA_SUCCESS":
      return fromJS(action.dataClient);
    default:
      return state;
  }
}

export function filterDataClient(state = initFilterDataClient, action) {
  switch (action.type) {
    case "FILTER_SET_INVOICE_NO_SUCCESS":
      return state.set("invoiceNo", action.invoiceNo);
    case "FILTER_SET_APL_SALES_OFFICE_SUCCESS":
      return state.set("aplSalesOffice", action.aplSalesOffice);
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set("pageNo", action.pageNo);
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set("pageSize", action.pageSize);
    default:
      return state;
  }
}

export function approvalClientDetail(state = fromJS([]), action) {
  switch (action.type) {
    case "APPROVAL_CLIENT_DETAIL_FETCH":
      return fromJS(action.detail);
    default:
      return state;
  }
}

export function valueClientData(state = fromJS([]), action) {
  switch (action.type) {
    case "VALUE_CLIENT_DATA_SUCCESS":
      return fromJS(action.detail);
    default:
      return state;
  }
}


